import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 28, className = "", as = "div" }) => {
  const M = motion[as];
  return (
    <M
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.12 }}
      transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </M>
  );
};

export const MaskLines = ({ lines, className = "", delay = 0.15, lineClass = "" }) => (
  <span className={className}>
    {lines.map((line, i) => (
      <span key={i} className="block overflow-hidden pb-[0.08em]">
        <motion.span
          className={`block ${lineClass}`}
          initial={{ y: "110%" }}
          animate={{ y: "0%" }}
          transition={{ duration: 1.1, delay: delay + i * 0.14, ease: [0.76, 0, 0.24, 1] }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </span>
);

export const PageHero = ({ eyebrow, title, intro, testid }) => (
  <section className="relative pt-36 pb-16 md:pt-44 md:pb-20 border-b hairline grain overflow-hidden" data-testid={testid}>
    <div className="absolute -top-40 right-0 w-[520px] h-[520px] rounded-full bg-[radial-gradient(circle,rgba(212,175,55,0.14),transparent_65%)] pointer-events-none" />
    <div className="relative max-w-7xl mx-auto px-5 md:px-10">
      <p className="eyebrow mb-6">{eyebrow}</p>
      <h1 className="font-display text-5xl sm:text-6xl lg:text-7xl font-medium leading-[0.98] text-slate-50 max-w-4xl">
        <MaskLines lines={Array.isArray(title) ? title : [title]} />
      </h1>
      {intro && (
        <motion.p
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.5 }}
          className="mt-8 max-w-2xl text-base md:text-lg text-slate-300 leading-relaxed"
        >
          {intro}
        </motion.p>
      )}
    </div>
  </section>
);
